import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';

import { BaseService } from '../base/util/base.service';
import { recuperarDemonstrativoPagAnalitico } from '../base/util/url-util';
import { recuperarDemonstrativoPagSintetico } from '../base/util/url-util';
import { Message } from 'primeng/components/common/api';
import { MessageService } from 'primeng/components/common/messageservice';

@Injectable()
export class DemonstrativoPagamentoService extends BaseService{
    
    constructor(public http: HttpClient,public messageService: MessageService){
        super(http,messageService);        
    }

    //Analítico
    recuperaDemonstrativoPagamentoAnalitico(dataCompetencia: string){
        return this.get(recuperarDemonstrativoPagAnalitico(dataCompetencia));
    }
   
    //Sintético
    recuperaDemonstrativoPagamentoSintetico(dataCompetencia: string){
        return this.get(recuperarDemonstrativoPagSintetico(dataCompetencia));
    }
    

}


// WEBPACK FOOTER //
// ./src/app/components/demonstrativo-pagamento/demonstrativo-pagamento.service.ts